var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolfGoal80Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 74,
    viewBox: "0 0 68 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 40.3333V3.66663L60.6667 17L34 30.3333",
    stroke: "#C3F0F7",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 31.1C64.2738 36.5671 64.4398 42.4288 62.9781 47.9875C61.5165 53.5462 58.4888 58.5681 54.2552 62.4556C50.0216 66.3431 44.7604 68.9327 39.0974 69.9161C33.4345 70.8995 27.6082 70.2355 22.3118 68.003C17.0154 65.7705 12.4718 62.0635 9.22158 57.323C5.97135 52.5825 4.15131 47.0082 3.978 41.2631C3.80469 35.518 5.2854 29.8441 8.24397 24.9163C11.2025 19.9885 15.5144 16.0144 20.6666 13.4667",
    stroke: "#C3F0F7",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 30.3333C18.9962 32.5567 17.9087 35.1627 17.5033 37.9139C17.0978 40.6651 17.3872 43.474 18.3451 46.0848C19.3031 48.6955 20.899 51.025 22.9876 52.8612C25.0761 54.6973 27.591 55.9816 30.3029 56.5971C33.0149 57.2126 35.8377 57.1398 38.5143 56.3852C41.1909 55.6306 43.6361 54.2183 45.6272 52.2769C47.6183 50.3354 49.0919 47.9267 49.9139 45.27C50.7358 42.6133 50.88 39.7932 50.3331 37.0666",
    stroke: "#C3F0F7",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfGoal80Px);
export default __webpack_public_path__ + "static/media/golf_goal_80px.269921929816a1d24965bea8fc815218.svg";
export { ForwardRef as ReactComponent };